import { render, staticRenderFns } from "./InsurerOffer.vue?vue&type=template&id=fee24b04&scoped=true"
import script from "./InsurerOffer.vue?vue&type=script&lang=ts"
export * from "./InsurerOffer.vue?vue&type=script&lang=ts"
import style0 from "./InsurerOffer.vue?vue&type=style&index=0&id=fee24b04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee24b04",
  null
  
)

export default component.exports